import { render, staticRenderFns } from "./DeadSpecimenByReasonModal.vue?vue&type=template&id=8332d906"
import script from "./DeadSpecimenByReasonModal.vue?vue&type=script&lang=js"
export * from "./DeadSpecimenByReasonModal.vue?vue&type=script&lang=js"
import style0 from "./DeadSpecimenByReasonModal.vue?vue&type=style&index=0&id=8332d906&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports